<template>
  <div id="main">
    <header :class="{ header: switchLeftSidebar }">
      <div header-wrap>
        <div menu-item>
          <img src="../assets/imgs/WechatIMG7003.png" />
        </div>
        <div menu-item v-for="(cm, index) in curMenu" :key="index" v-bind:class="{ 'menu-active': cm.code == navCode }"
          @click="navClick(cm, index)" class="nav">
          {{ cm.name }}
        </div>
      </div>
      <div header-user>
        <!-- <span header-user-type>{{curUser.DomainName}}</span>
                <span header-user-filter> | </span>-->
        <span header-user-type>{{ curUser.PRegionCode }}</span>
        <span header-user-filter>|</span>
        <span header-user-name>{{ curUser.UserName }}</span>
        <!-- 右侧设置按钮 -->
        <el-dropdown @command="onSwitchLeftSidebar">
          <span class="el-icon-setting set-icon"></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="left">
              <span>切换左侧栏</span>
            </el-dropdown-item>
            <el-dropdown-item command="exitLogin">
              <span>退出登录 </span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 退出登录 -->
        <!-- <router-link to="/login">
          <img header-user-img src="../assets/imgs/home/power.png" alt />
        </router-link> -->
      </div>
    </header>

    <div container :class="{ container: switchLeftSidebar }">
      <!-- 左侧侧导航 -->
      <div ref="leftWidth" container-item="left" id="container-item-left"
        :class="{ 'menu-min-width': isCollapse, 'left-nav': switchLeftSidebar }" class="nav">
        <el-scrollbar class="left-scrollbar" >
          <!-- 第二套布局 logo 位置 -->
          <div class="left-img" :class="{ leftImgMini: leftImgMini }" v-if="switchLeftSidebar">
            <img src="../assets/imgs/WechatIMG7003.png" />
          </div>
          <!-- 第1套侧边栏布局 -->
          <el-menu v-if="!switchLeftSidebar" :collapse="isCollapse" :collapse-transition="false" text-color="#fff" router
            background-color="#373f53" active-text-color="#429cfa" class="el-menu-vertical-demo"
            :default-openeds="openeds" :default-active="defaultActive">
            <el-submenu class="submenu" v-for="item in curSubMenus" v-show="item.ptype == 10" :index="item.path"
              :key="item.code">
              <template slot="title">
                <i :class="item.icon" aria-hidden="true"></i>
                <span slot="title">{{ item.name }}</span>
              </template>
              <el-menu-item class="second-menu-item" v-for="it in item.children" v-show="it.ptype == 10" :index="it.path"
                @click="clickTags(it)" :key="it.code">{{ it.name }}</el-menu-item>
            </el-submenu>
          </el-menu>
          <!-- 第二套侧边栏布局 -->
          <el-menu v-else class="el-menu-vertical-demo second-menu" :collapse="isCollapse" :collapse-transition="false"
            text-color="#fff" background-color="#3176ec" :popper-append-to-body="true">
            <!-- 弹出层组件    -->
            <!-- 控制台特殊处理 -->
            <el-menu-item class="second-menu-item" @click="goHome">
              <i class="el-icon-s-home" aria-hidden="true"></i>
              <span slot="title" class="dropdown-title">控制台</span>
            </el-menu-item>
            <!-- 中间列表 -->
            <el-tooltip v-for="(item, index) in curMenu" v-show="item.ptype == 10 || item.name != '控制台'" :key="index"
              class="second-menu-tooltip" effect="light" placement="right" :disabled="disabled">
              <el-menu-item class="second-menu-item" :index="index + ''" v-if="item.name != '控制台'" ref="secondMenu"
                @mousemove.enter.native="removeAllTooltip">
                <i :class="item.icon" aria-hidden="true"></i>
                <span slot="title" class="dropdown-title">
                  {{ item.name }}
                </span>
              </el-menu-item>
              <!-- 内容 -->
              <div slot="content" class="second-menu-tooltip-slot">
                <!-- 卡片组件 -->
                <el-card class="nav-box-card" v-for="(children, i) in item.children" v-show="children.ptype == 10"
                  :key="i">
                  <div slot="header" class="nav-clearfix">
                    <span :class="`${children.icon} nav-clearfix-icon is-highlight`"></span>
                    <span>{{ children.name }}</span>
                  </div>
                  <div class="nav-box-card-list" v-for="(d, v) in children.children" v-show="d.ptype == 10" :key="v"
                    @click="clickTags(d, 'leftNav', item, index)">
                    {{ d.name }}
                  </div>
                </el-card>
              </div>
            </el-tooltip>
            <!-- 设置 -->
            <el-tooltip class="second-menu-tooltip" effect="light" placement="right">
              <el-menu-item class="second-menu-item" @mousemove.enter.native="removeAllTooltip">
                <i class="el-icon-s-tools" aria-hidden="true"></i>
                <span slot="title" class="dropdown-title">设置</span>
              </el-menu-item>
              <!-- 内容 -->
              <div slot="content" class="second-menu-tooltip-slot">
                <el-card class="nav-box-card">
                  <div slot="header" class="nav-clearfix">
                    <span class="el-icon-s-tools is-highlight"></span>
                    <span>设置</span>
                  </div>
                  <div class="nav-box-card-list" @click="onSwitchLeftSidebar('top')">
                    切换顶部栏
                  </div>
                  <!-- <div class="nav-box-card-list" @click="exitLogin">
                    退出登录
                  </div> -->
                </el-card>
              </div>
            </el-tooltip>
            <!-- /占位自适应 -->
            <el-menu-item class="seize-a-seat" ref="seizeASeat" />
            <!-- 用户信息 -->
            <el-menu-item class="second-menu-user">
              <i v-if="!isCollapse" class="el-icon-user user-icon" aria-hidden="true"></i>
              <span slot="title" class="dropdown-user">
                <div class="dropdown-user-item">{{ curUser.PRegionCode }}</div>
                <div class="dropdown-user-item">{{ curUser.UserName }}</div>
              </span>
              <i class="el-icon-switch-button exit-switch" :class="{ 'is-exit': isExit }" aria-hidden="true"
                @click="exitLogin" ref="exitSwitch"></i>
            </el-menu-item>
          </el-menu>
        </el-scrollbar>
      </div>
      <!-- 右侧内容区 -->
      <div v-if="!homeTrue" container-item="right" id="container-item-right"
        :class="{ 'container-width-right': isCollapse }">
        <div class="table_zhao crumbs_zhao">
          <div class="table_left" style="display: flex">
            <div class="left_icon" v-show="curBreads[0].name != 'navHome'">
              <img src="@/assets/imgs/shouqicaidan.png" collapseIcon aria-hidden="true" @click="handleCollapse"
                v-if="left_icon" />
              <img src="@/assets/imgs/zhankaicaidan.png" collapseIcon aria-hidden="true" @click="handleCollapse" v-else />
            </div>
            <div class="tags_zhao" v-if="tagFalse" ref="tagFalse">
              <el-tag v-show="curBreads[0].name != 'navHome'" class="tag_zhao" v-for="tag in projectTags" :key="tag.name"
                :closable="tag.name != '首页'" :type="tag.type" @close="closeTags(tag)" @click="pathTags(tag)"
                :effect="tag.path == defaultActive ? 'dark' : 'light'">
                <!-- <div :ref="tag.path"></div> -->
                {{ tag.name }}
              </el-tag>
            </div>

            <!-- 横向面包屑 -->
            <!-- <el-breadcrumb
              separator-class="el-icon-arrow-right"
              v-show="curBreads[0].name != 'navHome'"
            >
              <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
              >
              <el-breadcrumb-item v-for="(b, indx) in curBreads" :key="indx"
                >{{ b.name }}
              </el-breadcrumb-item>
            </el-breadcrumb> -->
          </div>
          <!-- 方向左右隐藏 -->
          <!-- <div class="crumbs_icon">
            <div @click="crumbsIconClick">
              <i :class="crumbsI" class="crumbs_icons"></i>
            </div>
            <div class="right_icon">
              <img
                src="@/assets/imgs/spread-line.png"
                collapseIcon
                aria-hidden="true"
                @click="functionBtn"
                v-if="searchCondition"
              />
              <img
                src="@/assets/imgs/shouqi-copy.png"
                collapseIcon
                aria-hidden="true"
                @click="functionBtn"
                v-else
              />
            </div>
          </div> -->
          <div class="rightInfo">
            <el-dropdown trigger="click" class="dropdownMeun">
              <span class="el-dropdown-link">
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="closeAll">关闭所有</el-dropdown-item>
                <el-dropdown-item @click.native="closePrev">关闭当前</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <i v-if="hasShow" @click="fullScreen" class="iconfont icon-tubiao-21"></i>
            <i v-else @click="exitFullscreen" class="iconfont icon-quxiaoquanping"></i>
          </div>
        </div>

        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
      <!-- home 页面 -->
      <home v-if="homeTrue"></home>
    </div>
  </div>
</template>

<script>
import store from "../utils/storage";
import home from "./Home.vue";
import screenfull from "screenfull";
import addWatermark from '@/utils/watermark.js' // 引入水印方法
import moment from "moment";
export default {
  name: "navHome",
  components: { home },
  data() {
    return {
      isExit: false,
      homeTrue: false,
      navindex: 0, //点击的第几个导航
      navCode: "", //点击导航栏的code
      searchCondition: this.$store.state.searchCondition, //搜索条件显示隐藏
      defaultActive: "", //激活的左边菜单栏
      projectTags: this.$store.state.projectTags, //标签
      isCollapse: this.$store.state.indexHome, //左边菜单栏显示隐藏
      openeds: [],
      curSubMenus: "", //左边菜单栏数据
      curBreads: this.$router.history.current.matched, //面包屑
      curUser: store.getUserInfo(), //右边用户信息
      curMenu: store.getCurMenu(), //右边职位
      tagFalse: true, //标签页显示隐藏
      crumbsI: "el-icon-arrow-down", //图标
      left_icon: true, //左边菜单栏显示隐藏
      hasShow: true, //全屏与半屏的显隐
      switchLeftSidebar: false, // 左侧边栏模式是否打开
      leftImgMini: false, //左侧折叠后logo缩小
      disabled: false, // 左侧弹出菜单被点击后隐藏
    };
  },
  created() {
    if (this.$route.query.homeTrue) {
      this.homeTrue = this.$route.query.homeTrue;
      this.navCode = "main";
    } else {
      this.testfalse = false;
      this.navCode = window.sessionStorage.getItem("code");
      this.openeds = store.getOpeneds(window.sessionStorage.getItem("code"));
      this.curSubMenus = store.getSubMenus(
        window.sessionStorage.getItem("code")
      );
      //标签页图标切换
      if (this.$store.state.switchTags) {
        this.crumbsI = "el-icon-arrow-down";
      } else {
        this.crumbsI = "el-icon-arrow-right";
      }

      this.$router.push(window.sessionStorage.getItem("defaultUrl"));
      this.clickHeader(window.sessionStorage.getItem("defaultUrl")); //添加标签
      var ms = store.getMenus();
      if (ms.length === 0) this.$router.push({ path: "/login" });
    }
    // 初始化导航栏
    const navWay = localStorage.getItem("navWay")
      ? JSON.parse(localStorage.getItem("navWay"))
      : { navWay: true };
    this.switchLeftSidebar = navWay.navWay;
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    // 搜索条件显示隐藏
    functionBtn() {
      this.searchCondition = !this.searchCondition;
      this.$store.commit("searchConditionClick", this.searchCondition);
    },
    handleCollapse() {
      this.isCollapse = !this.isCollapse;
      this.left_icon = !this.left_icon;
      this.leftImgMini = this.isCollapse;
      this.$nextTick(() => {
        this.getBreadCrumbsWidth();
        this.getLeftUserHeight();
        const width = !this.$store.state.tableWidth;
        this.$store.commit("setTableWidth", width);
      });
      console.log(this.isCollapse);
      if (this.isCollapse) {
        this.isExit = this.isCollapse;
      } else {
        this.isExit = this.isCollapse;
      }
    },
    //一上来就添加标签
    clickHeader(path) {
      this.defaultActive = path;
      this.curMenu.forEach((it, i) => {
        it.children.forEach((item) => {
          item.children.forEach((ta) => {
            if (ta.path == path) {
              this.navindex = i;
              this.clickTags(ta);
            }
          });
        });
      });
    },
    // 点击添加标签
    clickTags(it, name, val, index) {
      // 点击当前激活的标签 不操作
      if(it.path !== this.defaultActive) {
        this.$store.commit("searchConditionClick", false);
      }
      
      if (name === "leftNav") {
        this.navClick(val, index, "leftNav");
      }
      it.curMenu = this.curMenu[this.navindex].code;
      this.defaultActive = it.path;
      let num = 0;
      this.projectTags.forEach((item) => {
        if (item.path.indexOf(it.path) != -1) {
          num++;
        }
      });
      if (num == 0) {
        this.projectTags.push(it);
        // this.$store.commit("saveDbSource", it);
      }
      //控制滚动条 使当前标签处在可视范围
      this.$nextTick(() => {
        let tag = 0;
        let tags = 0;
        if (this.$refs.tagFalse) {
          tags = this.$refs.tagFalse.offsetWidth;
        }
        let route = document.querySelectorAll(".tag_zhao");
        this.projectTags.forEach((item, i) => {
          if (item.path == it.path) {
            if(route[i] !== undefined) {
              tag = route[i].offsetLeft;
            }
          }
        });
        if (tag > tags) {
          if(this.$refs.tagFalse !== undefined) {
            this.$refs.tagFalse.scrollLeft = tag;
          }
        } else {
          if(this.$refs.tagFalse !== undefined) {
            this.$refs.tagFalse.scrollLeft = 0;
          }
        }
      });

      //左侧布局路由跳转
      if (name === "leftNav") {
        this.homeTrue = false;
        this.$router.push(it.path);
        this.disabled = true; // 自动隐藏
        setTimeout(() => {
          this.disabled = false; // 重置
        }, 500);
      }
    },
    // 关闭标签
    closeTags(tag) {
      // 不是当前激活的标签 不操作
      if (tag.path === this.defaultActive) {
        this.$store.commit("searchConditionClick", false);
      }
      
      this.projectTags.forEach((item, i) => {
        if (this.projectTags.length != 1) {
          if (item.path.indexOf(tag.path) != -1) {
            this.projectTags.splice(i, 1);
          }
        } else {
          this.projectTags.splice(i);
          this.goHome();
        }
      });
      if (tag.path == this.defaultActive) {
        this.$router.push(this.projectTags[this.projectTags.length - 1].path);
        this.defaultActive = this.projectTags[this.projectTags.length - 1].path;
        this.$nextTick(() => {
          this.navCode = this.projectTags[this.projectTags.length - 1].curMenu;
          this.openeds = store.getOpeneds(
            this.projectTags[this.projectTags.length - 1].curMenu
          );
          this.curSubMenus = store.getSubMenus(
            this.projectTags[this.projectTags.length - 1].curMenu
          );
        });
      }
    },
    // 跳转路由
    pathTags(tag) {
      // 是当前激活的标签 不操作
      if(tag.path !== this.defaultActive) {
        this.$store.commit("searchConditionClick", false);
      }
      
      this.curMenu.forEach((it, i) => {
        it.children.forEach((item) => {
          item.children.forEach((ta) => {
            if (ta.path == tag.path) {
              this.navindex = i; // 顶部当前的index
            }
          });
        });
      });
      this.defaultActive = tag.path; // 左侧当前激活菜单的index
      this.navCode = tag.curMenu; // 左侧高亮的css
      this.openeds = store.getOpeneds(tag.curMenu);
      this.curSubMenus = store.getSubMenus(tag.curMenu);
      // if (window.sessionStorage.getItem('infoQuery')) {
      //     this.projectTags.forEach((item) => {
      //         if (window.sessionStorage.getItem("infoQuery").indexOf(item.path) != -1) {
      //             tag.list = JSON.parse(window.sessionStorage.getItem('infoQuery'))
      //         }
      //     })
      // }
      this.$router.push({ path: tag.path, query: { tags: tag } });
      console.log(tag);
    },
    //标签显示与隐藏
    crumbsIconClick() {
      this.tagFalse = !this.tagFalse;
      if (this.tagFalse) {
        this.crumbsI = "el-icon-arrow-down";
      } else {
        this.crumbsI = "el-icon-arrow-right";
      }
    },
    navClick(val, index, navType) {
      this.$store.commit("searchConditionClick", false);
      this.navindex = index;
      this.navCode = val.code;
      this.openeds = store.getOpeneds(val.code);
      this.curSubMenus = store.getSubMenus(val.code);
      if (val.defaultUrl == "/home") {
        this.homeTrue = true;
      } else {
        this.homeTrue = false;
        this.$router.push(val.defaultUrl);
      }
      // 左侧导航时，不需要加载默认标签页
      if(navType !== 'leftNav') {
        this.clickHeader(val.defaultUrl);
      }
      this.$nextTick(() => {
        this.getBreadCrumbsWidth();
      })
    },
    // 下拉菜单关闭当前标签页面
    closePrev() {
      this.$store.commit("searchConditionClick", false);
      let flag = true;
      this.projectTags.forEach((item, i) => {
        if (this.projectTags.length != 1) {
          if (item.path === this.defaultActive) {
            this.projectTags.splice(i, 1);
          }
        } else {
          flag = false;
          this.projectTags.splice(i);
          this.goHome();
          return;
        }
      });
     if (!flag) return;
      const path = this.projectTags[this.projectTags.length - 1].path;
      const curMenu = this.projectTags[this.projectTags.length - 1].curMenu;
      this.$router.push(path);
      this.defaultActive = path;
      this.$nextTick(() => {
        this.navCode = curMenu;
        this.openeds = store.getOpeneds(curMenu);
        this.curSubMenus = store.getSubMenus(curMenu);
      });
    },
    // 下拉菜单关闭所有标签页面
    closeAll() {
      this.$store.commit("searchConditionClick", false);
      this.projectTags = [];
      this.$store.commit("delTags");
      this.goHome();
    },
    //全屏显示
    fullScreen() {
      var box = document.documentElement;
      if(box.requestFullscreen){
          box.requestFullscreen();
      }else if(box.webkitRequestFullscreen){
          //谷歌浏览器
          box.webkitRequestFullscreen();
      }else if(box.mozRequestFullScreen){
          //火狐浏览器
          box.mozRequestFullScreen();
      }else if(box.msRequestFullscreen){
          //IE浏览器
          box.msRequestFullscreen();
      }
    },
    //退出全屏
    exitFullscreen(){
        document.exitFullscreen();          
    },
    // 退出登录
    exitLogin() {
      this.$confirm("您确定退出登录吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push("/login");
          this.$message({
            type: "success",
            message: "退出成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退出！",
          });
        });
    },
    // 切换顶部和左侧边栏
    onSwitchLeftSidebar(command) {
      if (command === "left") {
        this.switchLeftSidebar = true;
        localStorage.setItem("navWay", JSON.stringify({ navWay: true }));
        this.$nextTick(() => {
          this.getLeftUserHeight();
        })
      }
      if (command === "top") {
        this.switchLeftSidebar = false;
        localStorage.setItem("navWay", JSON.stringify({ navWay: false }));
      }
      if (command === "exitLogin") {
        this.exitLogin();
      }
      this.$nextTick(() => {
        this.getBreadCrumbsWidth();
        const width = !this.$store.state.tableWidth;
        this.$store.commit("setTableWidth", width);
      })
      //表格高度适应
      const isShow = this.$store.state.searchCondition;
      this.$store.commit("searchConditionClick", !isShow);
      this.$store.commit("searchConditionClick", isShow);
    },
    // 跳转控制台
    goHome() {
      const data = this.curMenu.filter((d) => d.defaultUrl === "/home");
      const index = this.curMenu.findIndex((d) => d.defaultUrl === "/home");
      this.navClick(...data, index);
    },
    // 面包屑跨度
    getBreadCrumbsWidth() {
      if (this.$refs.tagFalse === undefined) return;
      const main = document.getElementById("main").clientWidth;
      const leftWidth = this.$refs.leftWidth.clientWidth;
      this.$refs.tagFalse.style.width = main - leftWidth - 167 + "px";
    },
    // 左侧个人信息位置监听
    getLeftUserHeight() {
      if (this.$refs.seizeASeat === undefined) return;
      const main = document.getElementById("main").clientHeight;
      const secondMenu = this.$refs.secondMenu.length * 40;
      this.$refs.seizeASeat.$el.style.height = main - secondMenu - 192 + "px";
    },
    // 实时检测屏幕大小
    handleResize(event) {
      this.getLeftUserHeight();
      this.getBreadCrumbsWidth();
    },
    // 菜单栏 tooltip提示关闭
    removeAllTooltip() {
      document.querySelectorAll('.el-tooltip__popper.is-dark').forEach((el) => el.remove());
    },
  },

  mounted() {
    // 添加水印
    const userInfo = JSON.parse(localStorage.getItem("cur-user-info"));
    if(userInfo.showWatermark) {
      const time = moment().format("YYYY-MM-DD");
      addWatermark({
        content: userInfo.UserName + time,
      });
    }
    

    this.getBreadCrumbsWidth();
    this.getLeftUserHeight();
    screenfull &&
    screenfull.enabled &&
    screenfull.onchange(() => {
      this.hasShow = !this.hasShow;
    });
  },
  computed: {
    projectTagsTrue() {
      return this.$store.state.projectTagsTrue;
    },
    // 生物导入导出跳转到生物样本管理
    toMaintainSKU() {
      return this.$store.state.toMaintainSKU;
    }
  },
  watch: {
    $route(to, from) {
      window.sessionStorage.setItem("defaultUrl", to.path);
      window.sessionStorage.setItem("code", this.navCode);
      this.curBreads = this.$router.history.current.matched;
    },
    projectTagsTrue: {
      handler(val) {
        if (!val) {
          this.projectTags = this.$store.state.projectTags;
          this.$store.commit("trueFalseTag", true);
        }
      },
      deep: true,
    },
    toMaintainSKU: {
      handler(isToPath) {
        console.log(isToPath);
        this.curMenu.forEach((item, index) => {
          if (item.defaultUrl === '/maintainSKU') {
            this.navClick(item, index);
            this.$store.commit('getToMaintainSKU', false);
          }
        });
      },
    },
    
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/main.css";

.nav {
  -webkit-touch-callout: none;
  /* iOS Safari */

  -webkit-user-select: none;
  /* Chrome/Safari/Opera */

  -khtml-user-select: none;
  /* Konqueror */

  -moz-user-select: none;
  /* Firefox */

  -ms-user-select: none;
  /* Internet Explorer/Edge */

  user-select: none;
  /* Non-prefixed version, currently

not supported by any browser */

  flex-shrink: 0;
}

/deep/.el-dropdown {
  font-size: 16px;
}

/dee/.el-scrollbar__bar.is-vertical {
  display: none;
}

// 左侧宽度字体右边距
/deep/.el-submenu__title>span {
  margin-right: 20px;
}

/deep/.el-menu-item i {
  color: #fff !important;
}

.header {
  height: 0;
  overflow: hidden;
}

.container {
  height: 100%;
  overflow: hidden;
}

.dropdown-title {
  font-size: 14px;
  color: #fff;
}

.dropdown-user {
  display: inline-block;
  height: 40px;
  font-size: 12px;
  color: #fff;

  .dropdown-user-item {
    height: 18px;
    line-height: 20px;
    margin-right: 5px;
  }
}

.second-menu-tooltip {
  width: 100%;
}

.left-img {
  width: 100px;
  height: 50px;
  margin-left: 20px;
  overflow: hidden;

  img {
    width: 100px;
    height: 50px;

    object-fit: contain;
  }
}

.leftImgMini {
  width: 42px;
  margin-left: 15px;
}

.second-menu-item {
  width: 100%;
  height: 40px;
  line-height: 40px;
}

.seize-a-seat {
  width: 100%;
  background-color: #3176ec !important;
  cursor: default !important;
}

.second-menu-user {
  height: 40px;
  line-height: 40px;
  width: 100%;
  background-color: #3176ec !important;
  cursor: default !important;
  position: relative;

  .exit-switch {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    // 鼠标变小手
    cursor: pointer;
  }

  .is-exit {
    right: 30%;
  }
}

.left-nav {
  background-color: #3176ec;
}

.set-icon {
  transform: translateY(1px);
}

// 左侧菜单 2级菜单
/deep/.el-card__header {
  border-bottom-color: #3176ec;
}

.second-menu-tooltip-slot {
  display: flex;
  max-width: calc(100vw - 170px);
  max-height: calc(100vh - 20px);
  background-color: #f2f9fe;
  border-radius: 10px;
  overflow: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);

  .nav-box-card {
    overflow: auto;
    flex-shrink: 0;
    background-color: #f2f9fe;

    .nav-clearfix {
      font-size: 14px;

      .nav-clearfix-icon {
        color: #1d90fa;
      }
    }

    .nav-box-card-list {
      color: #686f73;
    }

    &:hover {
      .nav-box-card-list {
        color: #000;
      }

      .is-highlight {
        color: #fff !important;
        background-color: #3176ec;
        border-radius: 2px;
        transition: all 0.3s linear 0.1s;
      }
    }
  }
}

// 左侧图标hover样式
/deep/.el-menu-item:hover {
  i {
    color: #3176ec !important;
    transition: all 0.3s linear 0.1s;
  }

  i::before {
    background-color: #fff;
    border-radius: 6px;
    transition: background-color 0.3s linear;
  }
}

.table_left {
  z-index: 1;
}

.header {
  z-index: 2;
}

.second-menu {
  border-top: 1px solid #d3cccc;
}
.left-scrollbar{
  /deep/ .el-scrollbar__wrap {
    margin-right: 0px!important;
    overflow:auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/navHome.vue